/**
 * The sending window right now, in words (19/10/2026, the Send window tile):
 * "Open · closes in 3 h 10 min" or "Opens in 2 h 15 min", on the country's
 * clock; null without a timezone or with an empty window. The window may
 * wrap past midnight.
 * For Media Devoted | Created By Ciro Autiero
 */
import { isWindowOpen, nowMinutesIn } from '../../../utils/plan-status';

/** "2 h 15 min", "45 min", "3 h". */
export function inWords(min: number): string {
  const h = Math.floor(min / 60);
  const m = min % 60;
  if (h === 0) return `${m} min`;
  return m === 0 ? `${h} h` : `${h} h ${m} min`;
}

const until = (from: number, to: number) => (to - from + 1440) % 1440;

export function windowNow(w: { startMin: number; endMin: number; tz: string | null }, now = new Date()): { open: boolean; text: string } | null {
  const nowMin = nowMinutesIn(w.tz, now);
  if (nowMin === null || w.startMin === w.endMin) return null;
  if (isWindowOpen(nowMin, w.startMin, w.endMin)) return { open: true, text: `Open · closes in ${inWords(until(nowMin, w.endMin))}` };
  return { open: false, text: `Opens in ${inWords(until(nowMin, w.startMin))}` };
}
